module.exports = __webpack_public_path__ + "img/term-of-use-jobmule.6777d05a.png";